import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import observeRootStore from '../../../components/hoc/observeRootStore';
import * as constants from '../../../appConstants';

import './locationPoints.scss';

export class LocationPoints extends Component {
    constructor(props) {
        super(props);
        this.state = {
            statePositionAvailable: this.props.mapRendered
        };
        this.locationObj = {}
    }

    componentDidMount() {
        this.setState({ statePositionAvailable: true });
        window.addEventListener('resize', this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    /**
     * Render list container for location points per state
     * if it contains a classList attribute
     * if classList is empty then we can assume there are no point locations
     *
     * Returns array of uls
     * @memberof LocationPoints
     */
    createStatePointGroups = () => {
        const stateData = this.props.stateData;
        const mapImage = document.querySelector('.country-map');
        const pointList = [];
        for (const key in stateData) {
            this.locationObj = stateData[key];
            if (this.locationObj.classList || this.locationObj.dealersCoordinates) {
                const stateImage = document.getElementById(key);
                this.locationObj.boxCoordinates = this.getStateBoxStats(stateImage, mapImage);
                pointList.push(
                    <ul className="location-points__state" key={key}>
                        {this.createLocationPointList(this.locationObj)}
                    </ul>
                );
            }
        }
        return pointList;
    };

    /**
     * Render array of location point dots into the state group
     * Using location logic from TUSA state map
     *
     * Returns array of list items
     * @memberof LocationPoints
     */
    createLocationPointList = stateObj => {
        const locations = [];
        // Split up class list string in array of location types
        const classListArray = stateObj.classList
            ? stateObj.classList.split(' ')
            : [];
        // create point for each location class type
        for (let i = 0; i < classListArray.length; i++) {
            if (classListArray[i].indexOf('has-') > -1) {
                const pointClass = classListArray[i];
                locations.push(
                    this.createLocationPointItem(stateObj, pointClass, i)
                );
            }
        }
        const dealersCoordinatesArray = stateObj.dealersCoordinates;
        // create point for each dealer coordinate
        for (let i = 0; i < dealersCoordinatesArray.length; i++) {
            locations.push(
                this.createLocationPointItem(
                    stateObj,
                    constants.FILTER_DEALERSHIPS,
                    `${i}-dealer`,
                    dealersCoordinatesArray[i]
                )
            );
        }
        return locations;
    };

    /**
     * Return li item for points list based on coordinate
     *
     * @param {*} stateObj
     * @param String pointClass
     * @param String key
     * @param Array coordinates
     * @returns LI element for location dot list
     * @memberof LocationPoints
     */
    createLocationPointItem(stateObj, pointClass, key, coordinates) {
        // If no coordinates are passed look up coordinate location based on pointClass
        const pointCoordinate = coordinates || (
            stateObj.coordinates[
                this.getCoordinateArrayPosition(pointClass)
            ] || [0, 0]
        );
        const boxCoordinates = this.locationObj.boxCoordinates;
        const x =
            boxCoordinates.x + (boxCoordinates.w * pointCoordinate[0]) / 100;
        const y =
            boxCoordinates.y + (boxCoordinates.h * pointCoordinate[1]) / 100;
        const pctX = (x / boxCoordinates.pW) * 100 - 0.25;
        const pctY = (y / boxCoordinates.pH) * 100 - 0.75;
        //Create style object for position dot over state based on percentage
        const pointPosition = {
            top: `${pctY}%`,
            left: `${pctX}%`
        };
        return (
            <li
                key={`${stateObj.country}${stateObj.abbreviation
                    }Point-${key}`}
                className={`location-points__point ${pointClass}`}
                style={pointPosition}
            />
        );
    }

    /**
     * Return object for position items relative to parent
     *
     * @memberof LocationPoints
     */
    getStateBoxStats = (child, parent) => {
        const childRect = child.getBoundingClientRect();
        const parentRect = parent.getBoundingClientRect();
        return {
            x: childRect.left - parentRect.left,
            y: childRect.top - parentRect.top,
            b: childRect.bottom - parentRect.bottom,
            w: childRect.width,
            h: childRect.height,
            pl: parentRect.left,
            pW: parentRect.width,
            pH: parentRect.height
        };
    };

    /**
     * Return position of coordinate for location dot
     * based on dot type from the classList attribute
     *
     * @memberof LocationPoints
     */
    getCoordinateArrayPosition = pointClass => {
        let coordinatePosition;
        switch (pointClass) {
            case constants.FILTER_DEALERSHIPS:
                coordinatePosition = 3;
                break;
            case constants.FILTER_RESEARCH_DEV:
                coordinatePosition = 2;
                break;
            case constants.FILTER_ENG_MAN:
                coordinatePosition = 1;
                break;
            case constants.FILTER_OFFICES:
            default:
                coordinatePosition = 0;
        }
        return coordinatePosition;
    };

    /**
     * Update state during window resize event
     * Position of points is relative to window position
     * so we have to re-render on width change
     */
    updateDimensions = () => {
        this.setState({
            height: window.innerHeight,
            width: window.innerWidth
        });
    };

    render() {
        return (
            <div
                className={`location-points ${this.props.rootStore.uiStore.selectedFilter
                    }`}
            >
                {this.state.statePositionAvailable &&
                    this.createStatePointGroups()}
            </div>
        );
    }
}

LocationPoints.propTypes = {
    rootStore: PropTypes.shape({
        uiStore: PropTypes.shape({
            selectedFilter: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
    mapRendered: PropTypes.bool,
    stateData: PropTypes.object.isRequired,
};

export default translate()(observeRootStore(LocationPoints));
